// Undergraduate/postgraduate school & program options, split by graduation era.
// Source: info/Courses-Offered-by-SMU-Re-Grouped.docx ("For Graduates on or
// before 2016" vs "For Graduates After 2016").
export const ERA_CUTOFF_YEAR = 2016;

// Returns true for years <= 2016 (the "old" curriculum/school-name era).
export function isOnOrBeforeCutoff(year) {
  const y = parseInt(year, 10);
  return !Number.isNaN(y) && y <= ERA_CUTOFF_YEAR;
}

const undergraduateProgramsOnOrBefore2016 = {
  "Accountancy": [
    "Bachelor of Science in Accountancy",
    "Bachelor of Science in Accounting Technology",
    "Bachelor of Science in Management Accounting",
  ],
  "Arts and Sciences": [
    "Associate in Arts",
    "Bachelor of Arts",
    "Bachelor of Arts (General Course)",
    "Bachelor of Arts in English",
    "Bachelor of Arts in Fine Arts",
    "Bachelor of Arts in Guidance and Counseling",
    "Bachelor of Arts in History",
    "Bachelor of Arts in Journalism",
    "Bachelor of Arts in Languages major in English",
    "Bachelor of Arts in Languages major in Filipino",
    "Bachelor of Arts in Mass Communication major in Journalism",
    "Bachelor of Arts in Philosophy",
    "Bachelor of Arts in Political Science",
    "Bachelor of Arts in Political Science and Legal Studies (double degree)",
    "Bachelor of Arts in Social Sciences",
    "Bachelor of Science in Biology",
    "Bachelor of Science in Chemistry",
    "Bachelor of Science in Economics",
    "Bachelor of Science in General Science",
    "Bachelor of Science in Mathematics",
    "Bachelor of Science in Psychology",
  ],
  "Business": [
    "Bachelor of Science in Business Administration major in Financial Management",
    "Bachelor of Science in Business Administration major in Marketing Management",
    "Bachelor of Science in Hotel and Restaurant Management",
    "Bachelor of Science in Office Administration",
    "Bachelor of Science in Tourism",
  ],
  "Commerce": [
    "Bachelor of Science in Commerce major in Accounting",
    "Bachelor of Science in Commerce major in Banking and Finance",
    "Bachelor of Science in Commerce major in Computer Science",
    "Bachelor of Science in Commerce major in Economics",
    "Bachelor of Science in Commerce major in Government Accounting and Auditing",
    "Bachelor of Science in Commerce major in Management",
    "Bachelor of Science in Commerce major in Marketing",
    "Bachelor of Science in Commerce major in Secretarial Administration",
    "Certificate in Food Management",
    "Collegiate Secretarial Course (1-year)",
  ],
  "Computing Science and Information Technology": [
    "Bachelor of Science in Computer Engineering",
    "Bachelor of Science in Computer Science",
    "Bachelor of Science in Information Systems",
    "Bachelor of Science in Information Technology",
  ],
  "Education": [
    "Bachelor in Library and Information Science",
    "Bachelor of Elementary Education (General Education)",
    "Bachelor of Elementary Education (Pre-School)",
    "Bachelor of Elementary Education with Certificate in Religious Education",
    "Bachelor of Science in Education",
    "Bachelor of Secondary Education major in English",
    "Bachelor of Secondary Education major in English with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Filipino",
    "Bachelor of Secondary Education major in Filipino with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Mathematics",
    "Bachelor of Secondary Education major in Mathematics with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Physical Science",
    "Bachelor of Secondary Education major in Physical Science with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Religious and Values Education",
    "Bachelor of Secondary Education major in Science",
    "Bachelor of Secondary Education major in Science with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Social Studies",
    "Bachelor of Secondary Education major in Social Studies with Certificate in Religious Education",
    "Junior Normal Course (Elementary Teacher’s Certificate)",
  ],
  "Engineering and Architecture": [
    "Associate in Geodetic Engineering",
    "Associate in Surveying",
    "Bachelor of Science in Architecture",
    "Bachelor of Science in Civil Engineering",
    "Bachelor of Science in Electrical Engineering",
    "Bachelor of Science in Electronics and Communications Engineering",
    "Bachelor of Science in Geodetic Engineering",
    "Bachelor of Science in Mechatronics (Robotics)",
    "Certificate in General Construction Technician",
    "Certificate in Surveying Aide",
    "Three-year Surveying Course",
  ],
  "Health Sciences": [
    "Associate in Health Sciences Education (2-year)",
    "Bachelor of Science in Medical Laboratory Science",
    "Bachelor of Science in Nursing",
    "Bachelor of Science in Pharmacy",
    "Bachelor of Science in Physical Therapy",
    "Certificate in Midwifery (2-year)",
  ],
  "Public Administration and Governance": [
    "Bachelor of Arts in Public Administration and Legal Studies (double degree)",
    "Bachelor of Arts in Public Administration and Political Science (double degree)",
    "Bachelor of Science in Criminology",
    "Bachelor of Science in Public Administration",
  ],
  "Expanded Tertiary Education Equivalency and Accreditation Program (ETEEAP)":
    [
      "Bachelor of Arts in English",
      "Bachelor of Early Childhood Education",
      "Bachelor of Elementary Education",
      "Bachelor of Science in Business Administration major in Financial Management",
      "Bachelor of Science in Business Administration major in Marketing Management",
      "Bachelor of Science in Commerce major in Management",
      "Bachelor of Science in Information Technology",
      "Bachelor of Science in Management Accounting",
      "Bachelor of Science in Office Administration",
      "Bachelor of Science in Public Administration",
      "Bachelor of Secondary Education",
    ],
};

const undergraduateProgramsAfter2016 = {
  "Accountancy and Business": [
    "Bachelor of Science in Accountancy",
    "Bachelor of Science in Accounting Information Systems",
    "Bachelor of Science in Accounting Technology",
    "Bachelor of Science in Business Administration major in Financial Management",
    "Bachelor of Science in Business Administration major in Marketing Management",
    "Bachelor of Science in Entrepreneurial Management",
    "Bachelor of Science in Entrepreneurship",
    "Bachelor of Science in Hospitality Management",
    "Bachelor of Science in Hotel and Restaurant Management",
    "Bachelor of Science in Management Accounting",
    "Bachelor of Science in Office Administration",
    "Bachelor of Science in Tourism",
    "Bachelor of Science in Tourism Management",
  ],
  "Engineering, Architecture, and Information Technology": [
    "Bachelor in Fine Arts major in Visual Communication",
    "Bachelor in Library and Information Science",
    "Bachelor of Science in Architecture",
    "Bachelor of Science in Civil Engineering",
    "Bachelor of Science in Computer Engineering",
    "Bachelor of Science in Computer Science",
    "Bachelor of Science in Electrical Engineering",
    "Bachelor of Science in Electronics and Communications Engineering",
    "Bachelor of Science in Electronics Engineering",
    "Bachelor of Science in Geodetic Engineering",
    "Bachelor of Science in Information Systems",
    "Bachelor of Science in Information Technology",
    "Bachelor of Science in Mathematics",
  ],
  "Health and Natural Sciences": [
    "Bachelor of Science in Biology",
    "Bachelor of Science in Biology major in Medical Biology",
    "Bachelor of Science in Biology major in Microbiology",
    "Bachelor of Science in Chemistry",
    "Bachelor of Science in Medical Laboratory Science",
    "Bachelor of Science in Nursing",
    "Bachelor of Science in Pharmacy",
  ],
  "Teacher Education and Humanities": [
    "Bachelor in Forensic Science",
    "Bachelor in Public Administration",
    "Bachelor in Special Needs Education with Specialization in Early Childhood Education with Certificate in Religious Education",
    "Bachelor of Arts in Communication",
    "Bachelor of Arts in English",
    "Bachelor of Arts in English Language Studies",
    "Bachelor of Arts in Guidance and Counseling (now Bachelor of Human Services)",
    "Bachelor of Arts in History",
    "Bachelor of Arts in Journalism",
    "Bachelor of Arts in Philosophy",
    "Bachelor of Arts in Political Science",
    "Bachelor of Culture and Arts Education with Certificate in Religious Education",
    "Bachelor of Early Childhood Education",
    "Bachelor of Elementary Education (General Education)",
    "Bachelor of Elementary Education (Pre-School)",
    "Bachelor of Elementary Education with Certificate in Religious Education",
    "Bachelor of Physical Education with Certificate in Religious Education",
    "Bachelor of Science in Criminology",
    "Bachelor of Science in Psychology",
    "Bachelor of Science in Social Work",
    "Bachelor of Secondary Education major in English with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Filipino with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Mathematics with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Physical Science with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Religious and Values Education",
    "Bachelor of Secondary Education major in Science",
    "Bachelor of Secondary Education major in Science with Certificate in Religious Education",
    "Bachelor of Secondary Education major in Social Studies with Certificate in Religious Education",
  ],
  "Expanded Tertiary Education Equivalency and Accreditation Program (ETEEAP)":
    [
      "Bachelor of Arts in English",
      "Bachelor of Early Childhood Education",
      "Bachelor of Elementary Education",
      "Bachelor of Science in Business Administration major in Financial Management",
      "Bachelor of Science in Business Administration major in Marketing Management",
      "Bachelor of Science in Commerce major in Management",
      "Bachelor of Science in Information Technology",
      "Bachelor of Science in Management Accounting",
      "Bachelor of Science in Office Administration",
      "Bachelor of Science in Public Administration",
      "Bachelor of Secondary Education",
    ],
};

// Master's/Doctorate programs are identical between eras in the source
// document; only the school/program labels changed.
const graduateStudiesPrograms = [
  "Innovative Master in Public Administration",
  "Master in Developmental Arts and Design",
  "Master in Engineering major in Civil Engineering",
  "Master in Public Administration (non-thesis)",
  "Master in Public Administration (with thesis)",
  "Master of Arts in Biology",
  "Master of Arts in Business Administration (non-thesis)",
  "Master of Arts in Chemistry",
  "Master of Arts in Chemistry (non-thesis)",
  "Master of Arts in Education major in Early Childhood Education",
  "Master of Arts in Education major in Educational Administration",
  "Master of Arts in Education major in Guidance and Counseling",
  "Master of Arts in Education major in Health Education",
  "Master of Arts in Education major in Library Science",
  "Master of Arts in Education major in Pedagogy",
  "Master of Arts in Education major in Physical Education",
  "Master of Arts in Education major in Reading",
  "Master of Arts in Education major in Religious Education",
  "Master of Arts in Education major in Special Education",
  "Master of Arts in English",
  "Master of Arts in English major in Literature",
  "Master of Arts in Language major in English",
  "Master of Arts in Mathematics (non-thesis)",
  "Master of Arts in Teaching major in Chemistry",
  "Master of Arts in Teaching major in Elementary Math",
  "Master of Arts in Teaching major in Elementary Science",
  "Master of Arts in Teaching major in English",
  "Master of Arts in Teaching major in Filipino",
  "Master of Arts in Teaching major in Physics",
  "Master of Arts in Teaching major in Secondary Biology",
  "Master of Arts in Teaching major in Secondary Mathematics",
  "Master of Arts in Teaching major in Social Studies",
  "Master of Education major in Pedagogy (non-thesis)",
  "Master of Education major in Pedagogy (with thesis)",
  "Master of Education major in Physical Education",
  "Master of Education major in Physical Education, Health, and Music",
  "Master of Library and Information Science",
  "Master of Science in Accountancy",
  "Master of Science in Biology",
  "Master of Science in Business Administration (with thesis)",
  "Master of Science in Information Technology",
  "Master of Science in Information Technology (twinned with SLU)",
  "Master of Science in Management Engineering",
  "Master of Science in Nursing major in Adult Health Nursing",
  "Master of Science in Nursing major in Community Health Nursing",
  "Master of Science in Nursing major in Maternal and Child Health Care",
  "Master of Science in Nursing major in Nursing Administration",
  "Master of Science in Teaching major in Mathematics",
  "Doctor in Public Administration",
  "Doctor in Public Administration (twinned with USLT)",
  "Doctor of Education major in Educational Management",
  "Doctor of Philosophy in Commerce major in Management",
  "Doctor of Philosophy in Science Education major in Biology",
  "Doctor of Philosophy in Science Education major in Mathematics",
  "Doctor of Philosophy major in Educational Management",
];

const postgraduateProgramsOnOrBefore2016 = {
  "Graduate Studies": graduateStudiesPrograms,
  "Law": ["Bachelor of Laws"],
};

const postgraduateProgramsAfter2016 = {
  "Graduate Studies (now Advanced Studies)": graduateStudiesPrograms,
  "College of Law": ["Bachelor of Laws (now Juris Doctor)"],
};

// `year` may be a bare year string/number (e.g. "2015") or free text (e.g.
// "N/A"); returns null when no valid year is available so callers can prompt
// for it before showing a program list.
export function getUndergraduateSchoolProgramMap(year) {
  if (Number.isNaN(parseInt(year, 10))) return null;
  return isOnOrBeforeCutoff(year)
    ? undergraduateProgramsOnOrBefore2016
    : undergraduateProgramsAfter2016;
}

export function getPostgraduateSchoolProgramMap(year) {
  if (Number.isNaN(parseInt(year, 10))) return null;
  return isOnOrBeforeCutoff(year)
    ? postgraduateProgramsOnOrBefore2016
    : postgraduateProgramsAfter2016;
}
